import { ModalTitle } from '@strava/ui/Modal';
import React, { useEffect } from 'react';
import PERMISSION_TYPES from '../../../../../../constants/consents/permissionTypes';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingLinkButton from '../../../OnboardingLinkButton';
import OnboardingModalActions from '../../../OnboardingModalActions';
import OnboardingUL from '../../../OnboardingUL/OnboardingUL';

import styles from './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  const { alert } = state;

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.privacyPolicy),
      action: 'screen_enter'
    });
  }, [track]);

  const privacyList = (() => {
    const result = [];
    for (let index = 1; index <= 4; index++) {
      result.push(
        <li key={`li-${index}`}>
          {t(`consents.privacy_policy.list.li_${index}`)}
        </li>
      );
    }
    return result;
  })();

  return (
    <>
      <ModalTitle id="onboarding-step-title">
        {t('consents.privacy_policy.title')}
      </ModalTitle>
      <ModalBodyWithAlerts className={styles.modal} alert={alert}>
        <p>{t('consents.privacy_policy.p_1')}</p>
        <OnboardingUL>{privacyList}</OnboardingUL>
        <OnboardingLinkButton href="/legal/privacy">
          {t('consents.privacy_policy.see_our_full_privacy_policy')}
        </OnboardingLinkButton>
      </ModalBodyWithAlerts>
      <OnboardingModalActions>
        <ActionButton
          variant="primary"
          onClick={() =>
            stepForward({
              action: ACTIONS.approved,
              permissionType: PERMISSION_TYPES.privacyPolicy
            })
          }
          data-cy="privacy-policy-next-step-btn"
          isProcessing={isProcessing}
          focus={true}
        >
          {t('cta_actions.continue')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default PrivacyPolicy;
